import { UnitActivationModifyPage } from '@apps-common/apps/portal/pages/units/pages/activations/pages/activation-modify/Index'

export const UnitActivationCreation = () => <UnitActivationModifyPage />
